import { useEffect } from "react";
import { useDisclosures } from "context/disclosures/useDisclosures";
import { DynamicComponentList } from "lib/dynamicComponentList";
import { DynamicComponent, getDynamicComponents, getDynamicComponentsContent } from "lib/utils";
import { Disclosures } from "types";
import { BaseContent, PageContent } from "types/graphql/generated";

function usePage<DisclosureContent>({
  disclosures,
  pageComponents,
  dynamicComponentList,
  baseContent,
  statePlans,
}: {
  disclosures: DisclosureContent;
  pageComponents: unknown[];
  dynamicComponentList: DynamicComponentList;
  baseContent: BaseContent;
  statePlans?: PageContent["statePlans"];
}) {
  const { setDisclosures } = useDisclosures();

  useEffect(() => {
    setDisclosures(disclosures as Disclosures);
  }, [setDisclosures, disclosures]);

  const components: DynamicComponent[] = getDynamicComponents<unknown[]>({
    pageComponents,
    dynamicComponentList,
  });

  const dynamicComponentsContent = getDynamicComponentsContent({
    pageComponents,
    baseContent,
    dynamicComponentList,
    statePlans,
  });

  return { components, dynamicComponentsContent };
}

export { usePage };
